<template>
    <div v-show="isModalVisible">
        <transition name="slide">
            <div class="modal-mask" @click="hide">
                <div class="modal-dialog modal-dialog-slideout modal-lg"  @click.stop>
                   <div class="modal-content  p-2">

                        <div class="modal-header">
                             <a href="javascript:void(0);" @click="hide" style="cursor: pointer;" class="text-uppercase text-muted pt-1"><img class="back_icon mr-2" src="@/assets/manager/back_button_icon.png" />Back</a>
                                <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="hide">
                                    <span aria-hidden="true">×</span>
                                </button>          
                        </div>                
                        
                        <div class="modal-body">
                          <div class="row">
                            <div class="col-7">
                              <div class="maheading_2">
                                <h5 class="modal-title">Renew Subscription</h5>
                              </div>  
                            </div>
                            <div class="col-5 text-right">
                              <div class="col-12 p-0">
                                Subscription Expires: {{ accountExpire }}
                              </div>
                            </div>
                          </div>


                            <div class="row pt-2" v-if="type == 'monthly'">
                              <div class="col-12 p-0 text-right pr-3">
                                <div class="chkboxwrapper">
                                  <div class="custom-control custom-checkbox">
                                    <input
                                      type="checkbox"
                                      id="annualSubscriptionp"
                                      name="annualSubscriptionp"
                                      ref="annualSubscriptionp"
                                      v-model="annualSubscription"
                                      :checked="annualSubscription" 
                                      @change="clickAnnualSubscriptionP($event)"
                                      class="custom-control-input"
                                      :value="1">
                                    <label class="custom-control-label" for="annualSubscriptionp">Switch to Annual Billing</label>
                                  </div>
                                </div>
                              </div>
                            </div>

                          <div class="mt-3 mb-3 py-2 px-3 subscription_box rounded shadow">
                            <div class="row">
                                <div class="col-8">
                                  {{ packageName }}
                                </div>
                                <div class="col-4 text-right seat_qty pr-3" v-if="type == 'monthly'">
                                  <div class="col-12 p-0">
                                  &#36;{{ packagePrice }}/monthly
                                  </div>
                                </div>
                                <div class="col-4 text-right seat_qty pr-3" v-else>
                                  <div class="col-12 p-0">
                                  &#36;{{ packagePrice }}/annually
                                  </div>
                                </div>
                            </div>
                            <div class="row pb-2" >
                              <div class="col-8 seat_qty">
                                <i>{{ packageQty }}</i>
                              </div>
                              <div class="col-4">
                                &nbsp;
                              </div>
                            </div>
                            <div class="row pb-1" v-if="additionalQty > 0">
                              <div class="col-6 pt-1">

                              </div>
                              <div class="col-6 text-right pr-3">
                                <div class="col-12 p-0">
                                Additional Seat {{ additionalQty }} : &#36;{{ additionalPrice }}
                                </div>
                              </div>
                            </div>
                            <div class="row pb-1" v-for="(seatDetail, index) in seatDetails" :key="index">
                              <div class="col-6 pt-1">

                              </div>
                              <div class="col-6 text-right pr-3">
                                <div class="col-12 p-0">
                                  <div class="row">
                                  <div class="col-9 p-0">{{ seatDetail.description }}:
                                  </div>
                                  <div class="col-3 p-0 pr-3">
                                     &#36;{{ seatDetail.amount }}
                                  </div>
                                  </div>
                                </div>
                                <div class="col-12 p-0" style="font-size: 12px !important;">
                                  <div class="row">
                                  <div class="col-9 p-0">({{ seatDetail.text }})
                                  </div>
                                  <div class="col-3 p-0">
                                    &nbsp;
                                  </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="row pb-1" >
                              <div class="col-6 pt-1">

                              </div>
                              <div class="col-6 text-right pr-3">
                                <div class="col-12 p-0">
                                Total: &#36;{{ totalAmount }}
                                </div>
                              </div>
                            </div>

                            <div class="clear"></div>
                          </div>
                          <div class="mt-3 mb-3 py-2 px-3 subscription_box rounded shadow">
                            <div class="row">
                                <div class="col-8">
                                  Payment Method
                                </div>
                                <div class="col-4 text-right pr-4">
                                    &nbsp;
                                </div>
                            </div>
                            <div class="row pb-2" v-if="cardName != ''">
                              <div class="col-3 seat_qty pt-1">
                                  {{ cardName }}
                              </div>
                              <div class="col-4  pt-1">
                                  {{ cardNo }}
                              </div>
                              <div class="col-2 pt-1">
                                  {{ cardExpire }}
                              </div>
                              <div class="col-3 text-right pr-2">
                                  <button type="submit" class="btn btn-md ma-blue-btn" @click="openPaymentListsModal">Edit</button>
                              </div>
                            </div>
                            <div class="row pb-2" v-else>
                              <div class="col-12 seat_qty text-center">
                                <i>No Payment Method found!</i>
                              </div>
                              <div class="col-12 text-center pt-2">
                                <button type="submit" class="btn btn-md ma-blue-btn" @click="openNewPaymentMethodModal()">Add New Payment Method</button>
                              </div>
                            </div>
                            <div class="clear"></div>
                          </div>



                          <div class="text-center m-4">
                              <button :disabled="process_payment_disable" type="button" class="btn btn-md ma-blue-btn" @click="onSubmit">
                                  Renew
                              </button>
                          </div>



                        </div>
                        <div class="modal-footer"></div>
                    </div>
                </div>
            </div>
        </transition>

        <NewPaymentMethod
          :isModalVisible="isNewPaymentMethodModalVisible"
          ref="NewPaymentMethodModal"
          @close="isNewPaymentMethodModalVisible = false">
        </NewPaymentMethod>

        <PaymentLists
          :isModalVisible="isPaymentListsModalVisible"
          ref="PaymentListsModal"
          @close="isPaymentListsModalVisible = false">
        </PaymentLists>

        <SubscriptionLists
          :isModalVisible="isSubscriptionListsModalVisible"
          :type="type"
          :annualSubscription="annualSubscription"
          ref="SubscriptionListsModal"
          @close="isSubscriptionListsModalVisible = false">
        </SubscriptionLists>




        <AddLicenseSuccessModal 
            :isAddLicenseSuccessModalVisible="isAddLicenseSuccessModalVisible"
            :paymentMethod="payment_method"
            :invoice_filename="invoice_filename"            
            :unitType="unitType"
            landingPage="adminconsole"
            ref="add_license_success"
            @close="close"
        />

        <AddLicenseFailedModal
            :isAddLicenseFailedModalVisible="isAddLicenseFailedModalVisible"
            :unitType="unitType"
            landingPage="adminconsole"
            @close="close"
        />


    </div>
  </div>

</template>
<script>
import Vue from 'vue/dist/vue.esm';
import router from '../../router/index.js';
import axios from 'axios';
import VeeValidate from 'vee-validate';
import moment from 'moment';
import { BPopover } from 'bootstrap-vue'
Vue.component('b-popover', BPopover)


import NewPaymentMethod from './new_payment_method.vue';
import PaymentLists from './payment_method_lists.vue';
import SubscriptionLists from './Renewsubscriptionlists.vue';
import AddLicenseSuccessModal from './add_license_success_modal.vue';
import AddLicenseFailedModal from './add_license_failed_modal.vue';

Vue.filter('formatExpirationDate', function(value) {
  if (value) {
    return moment(String(value)).format('MMMM DD, YYYY')
  }
});

Vue.use(VeeValidate, { errorBagName: 'verrors', fieldsBagName: 'vfields'});

export default {
    props: ['isModalVisible', 'type'],
    data() {
        return {
          loading: false,
          subscriptions: [],
          unitType: '',
          packageName: '',
          packageQty: 0,
          autoRenewal: '',
          renewalDate: '',
          additionalSeat: 0,
          cardName: '',
          cardNo: '',
          cardExpire: '',
          isNewPaymentMethodModalVisible: false,
          isPaymentListsModalVisible: false,
          orderItems: [],
          purchaseLoading: false,
          isProcessPaymentModalVisible: false,
          isSubscriptionListsModalVisible: false,
          isSubscriptionListsMonthlyModalVisible: false,
          packageId: '',
          billing_name: '',
          billing_address: '',
          billing_address2: '',
          billing_city: '',
          billing_state: '',
          billing_country: '',
          billing_zip: '',
          billing_phone: '',
          payment_method: 'credit_card',
          units: '',
          NtotalAmount: '',
          isAddLicenseSuccessModalVisible: false,
          isAddLicenseFailedModalVisible: false,
          totalLicense: '',
          usedLicense: '',
          accountExpire: '',
          invoice_filename: '',
          additionalQty: '',
          additionalPrice: '',
          subscriptionPrice: '',
          seatDetails: [],
          annualSubscription: false,
          type: '',
          unlimited: false,
          process_payment_disable: false,
        }
    },
    components: {
      NewPaymentMethod,
      PaymentLists,
      SubscriptionLists,
      AddLicenseSuccessModal,
      AddLicenseFailedModal,
    },
    methods: {       
        hide() { 
            this.$emit('close');
        },
        clickAnnualSubscriptionP(event) {
          if(event.target.checked == true) {
            this.annualSubscription = true;
          }
          else {
            this.annualSubscription = false;
          }
          this.getSubscriptionDetails();
        },
        onSubmit() {
          axios('/subscription-renew-orders', 
          {
            method: 'POST',
            data: {
              "subscription_id": this.subscriptionId,
              "subscription_price": this.subscriptionPrice,
              "units": this.units,
              "annualSubscription": this.annualSubscription,
              "type": this.type,
              "subscription_total": this.NtotalAmount,
              "account_id": this.$store.state.user_accountid,
              "additionalSeat": this.additionalSeat,
              "packageId": this.packageId,
              "billing_name": this.billing_name,
              "billing_address": this.billing_name,
              "billing_address2": this.billing_address2,
              "billing_city": this.billing_city,
              "billing_state": this.billing_state,
              "billing_country": this.billing_country,
              "billing_zip": this.billing_zip,
              "billing_phone": this.billing_phone,
              "payment_method": this.payment_method,
            },
          })
          .then((response) => {
              this.process_payment_disable = false;
              this.verrors.clear();
              this.invoice_filename = response.data.invoice_filename;
              if (response.data.msg != 'failed') {
                  this.isAddLicenseSuccessModalVisible = true;
              } else {
                  this.isAddLicenseFailedModalVisible = true;
              }

          })
          .catch(error => {
              this.process_payment_disable = false;
          });

        },

        openSubscriptionListsModal() {
          this.isSubscriptionListsModalVisible = true;
          this.$refs.SubscriptionListsModal.loadInitialData();
        },
        openSubscriptionListsMonthlyModal() {
          this.isSubscriptionListsMonthlyModalVisible = true;
          this.$refs.SubscriptionListsMonthlyModal.loadInitialData();
        },
        openNewPaymentMethodModal() {
          this.isNewPaymentMethodModalVisible = true;
          this.$refs.NewPaymentMethodModal.loadInitialData();
        },
        openPaymentListsModal() {
          this.isPaymentListsModalVisible = true;
          this.$refs.PaymentListsModal.loadInitialData();
        },
        closePaymentMethod() {
          this.isNewPaymentMethodModalVisible = false;
          this.getPrimaryPaymentDetails();
        },
        closePaymentMethodLists() { 
          this.isPaymentListsModalVisible = false;
          this.getPrimaryPaymentDetails();
        },
        close() {
            this.verrors.clear();
            if (this.close_url) {
                let routeData = this.$router.resolve({name: this.close_url});
                window.open(routeData.href, '_self');
            } else {
                let routeData = this.$router.resolve({name: 'managelicense'});              
                window.open(routeData.href, '_self');                
            }
        },
        onClose() {
          this.popoverShow = false
        },


        getPrimaryPaymentDetails() {

          axios('/desktop/get-payment-details/'+ this.$store.state.user_accountid,
          {
            method: 'GET'        
          })
          .then(resp => {        
            this.cardName = resp.data.cardName;
            if(this.cardName == '') {
              this.process_payment_disable = true;
            }
            else {
              this.process_payment_disable = false;
            }
            this.cardNo = resp.data.cardNo;
            this.cardExpire = resp.data.cardExpire;
            this.billing_name = resp.data.billing_name;
            this.billing_address = resp.data.billing_address;
            this.billing_address2 = resp.data.billing_address2;
            this.billing_city = resp.data.billing_city;
            this.billing_state = resp.data.billing_state;
            this.billing_country = resp.data.billing_country;
            this.billing_zip = resp.data.billing_zip;
            this.billing_phone = resp.data.billing_phone;
          })
          .catch(() => {
          });      

        },
        closeSubscriptionListsModal(packageId) {
          this.packageId = packageId;
          this.loadInitialData();
        },
        getSubscriptionDetails() {

          axios('/desktop/get-account-renew-subscription/'+ this.$store.state.user_accountid,
          {
            method: 'GET',  
            params: {
              packageId: this.packageId,
              annualSubscription: this.annualSubscription,
            }

          })
          .then(resp => {        
            this.unlimited = resp.data.unlimited;
            this.unitType = resp.data.unitType;
            this.packageName = resp.data.packageName;
            this.packageQty = resp.data.packagQty;
            this.packagePrice = resp.data.packagePrice;
            this.totalAmount = resp.data.totalAmount;
            this.subscriptionId = resp.data.subscriptionId;
            this.todayDate = resp.data.todayDate;
            this.units = resp.data.units;
            this.additionalQty = resp.data.additionalQty;
            this.additionalPrice = resp.data.additionalPrice;
            this.NtotalAmount = resp.data.NtotalAmount;
            this.renewalDate = resp.data.accountExpire;
            this.totalLicense = resp.data.totalLicense;
            this.usedLicense = resp.data.usedLicense;
            this.accountExpire = resp.data.accountExpire;
            this.seatDetails = resp.data.seatDetails;
            this.subscriptionPrice = resp.data.subscriptionPrice; 
            this.type = resp.data.type;
          })
          .catch(() => {
          });      

        },
        loadInitialData() {
            this.getSubscriptionDetails();
            this.getPrimaryPaymentDetails();
        },
    },
    created() {

    }   
}
</script>
<style scoped>
.back_icon { width: 14px; }
::-webkit-scrollbar {
    width: 0;  /* Remove scrollbar space */
    background: transparent;  /* Optional: just make scrollbar invisible */
}
.modal-mask {
    position: fixed;
    z-index: 1001;
    top: 59px;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .5);
    transition: opacity .3s ease;
    overflow-y: scroll;
}
.modal-dialog {
  animation: slide-in 1s forwards;
  -webkit-animation: slide-in 1s forwards;
}

@keyframes slide-in {
  0% {
    -webkit-transform: translateX(100%);
  }
  100% {
    -webkit-transform: translateX(0%);
  }
}

@-webkit-keyframes slide-in {
  0% {
    transform: translateX(100%);
  }
  100% {
    transform: translateX(0%);
  }
}
.modal-dialog {
  max-width: 90%;
}
@media (min-width: 992px) {
    .modal-lg, .modal-xl { width: 700px; }
}
@media (max-width: 576px){ 
    .modal-dialog.modal-dialog-slideout { width: 80% }
}
.modal-dialog-slideout {
    min-height: 100%; margin: 0 0 0 auto; background: #fff; 
}
.modal-dialog-slideout .modal-content{ border: 0; }
.modal-header { border-bottom: none; }
.modal-footer { border-top: none; }
.modal-goback { font-size: 24px; margin: 5px 10px 0 0; cursor: pointer; }
.modal-title { font-weight: 900; }
.modal-body { padding: 0rem 1.5rem 0rem 1.5rem; overflow: auto;}
.maheading_1 { width: 5%; }
.maheading_2 { width: 75%; }
.maheading_3 { width: 20%; }
.rounded {
    border-radius: 10px !important;
    padding: 20px;
    border: 1px solid #B8B7B8;
}
.seat_qty {
    font-size: 13px;
}
.receipt-heading {
  float: left;
  font-weight: normal;
  font-size: 14px;
  text-decoration: underline;
}
.receipt-heading-1{
  width: 18%;
}
.receipt-heading-4 {
  width: 22%;
  text-align: right;
}
.receipt-heading-3 {
  width: 18%; 
}
.receipt-heading-6 {
  width: 12%; 
}
.receipt-heading-2 {
  width: 30%;
}
.receipt {
  font-weight: normal;
  text-decoration: none;
  float: left;
  font-size: 13px;
  padding-top: 8px;
}
</style>




// WEBPACK FOOTER //
// src/components/manager/RenewSubscription_changedpricingaffiliate.vue